module.exports = __webpack_public_path__ + "workspace/static/img/renewalManagerSix.07b6ae3.png";